// src/components/terms/Terms.js
import React from "react";
import "./Terms.css";

export default function Terms() {
    return (
        <div className="terms-container">
            <h1>Terms & Conditions</h1>
            <p>Last updated: {new Date().toLocaleDateString("en-GB")}</p>

            <section>
                <h2>1. Software Service Only</h2>
                <p>
                    This application is provided as a booking and management tool. We are
                    not responsible for the quality, delivery, or outcome of services
                    offered by salons listed in the app.
                </p>
            </section>

            <section>
                <h2>2. Independent Salons</h2>
                <p>
                    All salons are independent businesses. Any disputes, cancellations,
                    refunds, or service issues must be resolved directly with the salon.
                </p>
            </section>

            <section>
                <h2>3. Customer Responsibility</h2>
                <p>
                    Customers are responsible for providing accurate information such as
                    name, contact details, and booking preferences.
                </p>
            </section>

            <section>
                <h2>4. Salon Responsibility</h2>
                <p>
                    Salons are responsible for managing their own schedules, staff
                    availability, and service quality.
                </p>
            </section>

            <section>
                <h2>5. No Liability</h2>
                <p>
                    We do not assume liability for missed appointments, service
                    dissatisfaction, payments, or any loss/damage arising from
                    salon-customer interactions.
                </p>
            </section>

            <section>
                <h2>6. Changes to Terms</h2>
                <p>
                    These terms may be updated periodically. Continued use of the app
                    indicates acceptance of the updated terms.
                </p>
            </section>
        </div>
    );
}
